// import * as React from "react";
// import { makeStyles } from "@mui/styles";
// import Box from "@mui/material/Box";
// import Paper from "@mui/material/Paper";
// import Grid from "@mui/material/Grid";
// import { styled } from "@mui/styles";
// import { Typography } from "@mui/material";
// import { createTheme } from "@mui/material/styles";
// import { useSelector } from "react-redux";

// import AvatarText from "../common/avatarWithText";
// import SecondaryNavTitle from "../navbar/sideNavbar/SecondaryNavTitle";
// import CustomTheme from "./../common/CustomTheme";
// import { IState } from "../../redux/reducers/rootReducers";

// // use your actual icon here
// import userIcon from "../../assest/dashboard-icons/users.svg";
// // or import azureIcon from "../../assest/dashboard-icons/azure-users.svg";

// const theme: any = createTheme();
// const data = CustomTheme();
// const mode = data.theme;

// const useStyles = makeStyles(() => ({
//   root: {
//     display: "flex",
//   },
//   box: {
//     backgroundColor: mode.solids,
//     padding: "20px",
//   },
//   typography: {
//     marginLeft: 10,
//   },
//   title: {
//     fontSize: "24px",
//     lineHeight: "29px",
//     fontWeight: 600,
//     color: "#2a2765",
//     marginBottom: "20px",
//   },
// }));

// const Item = styled(Paper)(() => ({
//   ...theme.typography.body1,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

// const AzureManagement: React.FC = () => {
//   const [azureModules, setAzureModules] = React.useState([] as any);
//   const rolesAccess = useSelector((state: IState) => state?.LoginReducer?.roleAccess);
//   const classes = useStyles();

//   React.useEffect(() => {
//     let azureFields: any[] = [];

//     if (!rolesAccess) {
//       return;
//     }

//     if (rolesAccess?.isSuperAdmin || rolesAccess?.azureMngmtAccess) {
//       azureFields.push({
//         avatarText: "Azure Users",
//         avatarURL: userIcon,
//         avatarAlt: "Azure Users",
//         redirectLink: "/AzureManagement/AzureUsers",
//       });
//     }

//     setAzureModules([...azureFields]);
//   }, [rolesAccess]);

//   return (
//     <>
//       <SecondaryNavTitle pageTitle={"Azure Management"} />
//       <Box sx={{ flexGrow: 1 }} className={classes.box}>
//         <Typography className={classes.title}>Azure Management</Typography>

//         <Grid container spacing={2}>
//           {azureModules.map((mgt: any, index: number) => {
//             return (
//               <Grid item xs={4} key={index}>
//                 <Item>
//                   <AvatarText
//                     avatarText={mgt.avatarText}
//                     avatarURL={mgt.avatarURL}
//                     avatarAlt={mgt.avatarAlt}
//                     isExtLink={false}
//                     redirectLink={mgt.redirectLink}
//                   />
//                 </Item>
//               </Grid>
//             );
//           })}
//         </Grid>
//       </Box>
//     </>
//   );
// };

// export default AzureManagement;

import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/styles";
import { Typography } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";

import AvatarText from "../common/avatarWithText";
import CustomTheme from "../common/CustomTheme";
import { IState } from "../../redux/reducers/rootReducers";

import userIcon from "../../assest/dashboard-icons/users.svg";

const theme = createTheme();
const data = CustomTheme();

const Item = styled(Paper)(() => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "red",
}));

const AzureManagement: React.FC = () => {
  const rolesAccess = useSelector((state: IState) => state?.LoginReducer?.roleAccess);
  const toggleTheme = useSelector((state: IState) => state.theme.theme);

  const [mode, setMode] = useState({} as any);
  const [azureModules, setAzureModules] = useState([] as any);

  useEffect(() => {
    if (toggleTheme) {
      setMode(data.all.dark);
    } else {
      setMode(data.all.light);
    }
  }, [toggleTheme]);

  const useStyles = makeStyles(() => ({
    root: {
      display: "flex",
    },
    box: {
      backgroundColor: mode.solids,
      padding: "20px",
      "& .thumb": {
        lineHeight: "1",
      },
    },
    typography: {
      marginLeft: 10,
    },
    title: {
      fontSize: "24px",
      lineHeight: "29px",
      color: mode.text,
      marginBottom: "20px",
      "@media screen and (max-width : 980px)": {
        fontSize: "15px",
        marginBottom: "5px",
      },
    },
  }));

  useEffect(() => {
    let azureFields: any[] = [];

    if (!rolesAccess) {
      return;
    }

    if (rolesAccess?.isSuperAdmin || rolesAccess?.azureMngmtAccess) {
      azureFields.push({
        avatarText: "Azure Users",
        avatarURL: userIcon,
        avatarAlt: "Azure Users",
        redirectLink: "/AzureManagement/AzureUsers",
      });
    }

    setAzureModules([...azureFields]);
  }, [rolesAccess]);

  const classes = useStyles();

  return (
    <>
      <Box sx={{ flexGrow: 1 }} className={classes.box}>
        <Typography className={classes.title}>Azure Management</Typography>

        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {azureModules.map((mgt: any, index: number) => {
            return (
              <Grid item xs={6} md={4} className="thumbs" key={index}>
                <Item style={{ backgroundColor: `${mode.body}` }}>
                  <AvatarText
                    avatarText={mgt.avatarText}
                    avatarURL={mgt.avatarURL}
                    avatarAlt={mgt.avatarAlt}
                    redirectLink={mgt.redirectLink}
                    isExtLink={false}
                  />
                </Item>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default AzureManagement;